import React from 'react';
import { AllocationRulesContextProvider } from './context';
import AllocationRules from './index';

export const AllocationRulesWrapper = () => {
  return (
    <AllocationRulesContextProvider>
      <AllocationRules />
    </AllocationRulesContextProvider>
  );
};
